var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-list" }, [
    _c("header", [_vm._v(_vm._s(_vm.$t("chatbotv2.archive")))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "archives-list" },
      [
        _c("FilterTool", {
          attrs: {
            getAllVisitorId: _vm.getAllVisitorId,
            getConversationById: _vm.getConversationById,
          },
          model: {
            value: _vm.cloneFilters,
            callback: function ($$v) {
              _vm.cloneFilters = $$v
            },
            expression: "cloneFilters",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { ref: "msgContainer", staticClass: "archives-list-list" },
          [
            !_vm.items.length && !_vm.loading
              ? _c("EmptyFilterResult", {
                  attrs: {
                    "clear-filters": function () {
                      return (_vm.cloneFilters = {})
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.items, function (item) {
              return _c(
                "div",
                {
                  key: item._id,
                  staticClass: "archives-list-item",
                  class: { active: _vm.activeChatId === item._id },
                  attrs: { id: item._id },
                  on: {
                    click: function ($event) {
                      return _vm.onConversationSelected(item._id)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "source" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(item.fullname)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "date" }, [
                    _vm._v(_vm._s(_vm.createdTimeHumanize(item))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cb_messages" },
                    [
                      !item.messages.length
                        ? _c("span", { staticClass: "form" }, [
                            _c("span", { staticClass: "cb_message" }, [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.noMessage"))),
                            ]),
                          ])
                        : _vm._l(item.messages, function (message) {
                            return _c(
                              "span",
                              {
                                key: message.uniqMessageId,
                                staticClass: "from",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    "" +
                                      (message.messageType === "chatbot"
                                        ? "B"
                                        : message.messageType === "visitor"
                                        ? "K"
                                        : "T")
                                  ) + ":"
                                ),
                                _c("span", { staticClass: "cb_message" }, [
                                  _vm._v(_vm._s(message.description)),
                                ]),
                              ]
                            )
                          }),
                    ],
                    2
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _vm.loading
              ? _c(
                  "div",
                  _vm._l(5, function (skeleton) {
                    return _c("div", { staticClass: "col m-3" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("a-skeleton", {
                              attrs: { active: true, paragraph: { rows: 0 } },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("a-skeleton", {
                              staticClass: "skeleton-date",
                              attrs: { active: true, paragraph: { rows: 0 } },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c("a-skeleton", {
                            staticClass: "col skeleton-message-content",
                            attrs: { active: true, paragraph: { rows: 0 } },
                          }),
                          _vm._v(" "),
                          _c("a-skeleton", {
                            staticClass: "col skeleton-message-content",
                            attrs: { active: true, paragraph: { rows: 0 } },
                          }),
                          _vm._v(" "),
                          _c("a-skeleton", {
                            staticClass: "col skeleton-message-content",
                            attrs: { active: true, paragraph: { rows: 0 } },
                          }),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                )
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-row align-items-center justify-content-center my-3",
          },
          [
            _vm.showLoadMore
              ? _c(
                  "a-button",
                  {
                    staticClass: "w-50",
                    staticStyle: { background: "#f5f8fb" },
                    attrs: { loading: _vm.loading },
                    on: { click: _vm.loadMore },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.loading
                          ? _vm.$t("chatbotv2.loading")
                          : _vm.$t("chatbotv2.loadMore")
                      ) + "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }